import {
  AccountCircle,
  Description,
  Pets,
  RememberMe,
 
} from "@mui/icons-material";

// import StyleGuide from "../views/StyleGuide/StyleGuide";
import RouteName from "./Route.name";
import Constants from "../config/constants";
import { lazy } from "react";

const AppUsersList = lazy(()=> import ("../views/AppUsers/AppUsersList"));
const AppUsersDetail = lazy(()=> import ("../views/AppUsers/Detail/AppUsersDeatil"));
const PatientDetail = lazy(()=> import ("../views/PatientProfile/Detail/PatientDetail.view"));
const AppointmentDashView = lazy(()=> import ("../views/AppoinmentDash/Components/ListView/Listview"));
const Myprofile = lazy(()=> import ("../views/MyProfile/Detail/MyProfile"));

const dashboardRoutes = [
  // {
  //   path: "/",
  //   sidebarName: "Dashboard",
  //   icon: Dashboard,
  //   component: PatientDetail,
  //   is_sidebar: true,
  // },
  // {
  //   path: `${RouteName.STYLE_GUIDE}`,
  //   sidebarName: "Style Guide",
  //   icon: FormatShapes,
  //   component: StyleGuide,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.APPOINTMENT,
  //   sidebarName: "Appointment",
  //   icon: Description,
  //   component: AppointmentListView,
  //   is_sidebar: true,
  //   // module: Constants.MODULES.PROGRAM_MANAGEMENT,
  //   // permissions: ["read"],
  // },

  {
    path: RouteName.APPOINTMENT,
    sidebarName: "Appointments",
    icon: Description,
    component: AppointmentDashView,
    is_sidebar: true,
    // module: Constants.MODULES.PROGRAM_MANAGEMENT,
    // permissions: ["read"],
  },
  
  {
    path: RouteName.My_PROFILE,
    sidebarName: "Profile",
    icon: AccountCircle,
    component: Myprofile,
    is_sidebar: true,
    // module: Constants.MODULES.PROGRAM_MANAGEMENT,
    // permissions: ["read"],
  },
  

  // {
  //   path: RouteName.PROGRAM_CREATE,
  //   sidebarName: "Program Management",
  //   parentRoute: `${RouteName.PROGRAM}`,
  //   icon: Description,
  //   component: ProgramCreate,
  //   is_sidebar: false,
  //   module: Constants.MODULES.PROGRAM_MANAGEMENT,
  //   permissions: ['read', 'create', 'update']
  // },
  // {
  //   path: `${RouteName.PROGRAM_UPDATE}:id`,
  //   sidebarName: "Program Management",
  //   parentRoute: `${RouteName.PROGRAM}`,
  //   icon: Description,
  //   component: ProgramCreate,
  //   is_sidebar: false,
  // },
  {
    path: `${RouteName.PATIENT_DETAIL}:id`,
    sidebarName: "Program Management",
    parentRoute: `${RouteName.PROGRAM}`,
    icon: Description,
    component: PatientDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.APPOINTMENT}`,
  },
  {
    path: RouteName.APP_USERS,
    sidebarName: "App Users",
    icon: RememberMe,
    component: AppUsersList,
    is_sidebar: true,
    module: Constants.MODULES.APP_USERS,
    permissions: ["read"],
  },
  {
    path: `${RouteName.APP_DETAIL}:id`,
    sidebarName: "App Users",
    parentRoute: `${RouteName.APP_USERS}`,
    icon: RememberMe,
    component: AppUsersDetail,
    is_sidebar: false,
    module: Constants.MODULES.APP_USERS,
    permissions: ["read"],
  },
];

export default dashboardRoutes;
